import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import OverrideServerPropertiesIntro from './override-server-properties-intro.mdx';
import OverrideGeoIPPropertiesIntro from './override-geoip-properties-intro.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <OverrideServerPropertiesIntro mdxType="OverrideServerPropertiesIntro" />
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`curl -v -L --header "Content-Type: application/json" -d '  {
    "api_key": "<ph_project_api_key>",
    "distinct_id": "distinct_id_of_your_user",
    "groups" : { # Required only for group-based feature flags
        "group_type": "group_id" # Replace "group_type" with the name of your group type. Replace "group_id" with the id of your group.
    },
    "person_properties": {"<personProp1>": "<personVal1>"},
    "group_properties": {"group_type": {"property_name":"property_value"}} # 
}' https://us.posthog.com/decide?v=3 # or https://eu.posthog.com/decide?v=3
`}</code></pre>

    <OverrideGeoIPPropertiesIntro mdxType="OverrideGeoIPPropertiesIntro" />
    <p>{`To override the GeoIP properties used to evaluate a feature flag, provide an IP address in the `}<inlineCode parentName="p">{`HTTP_X_FORWARDED_FOR`}</inlineCode>{` when making your `}<inlineCode parentName="p">{`/decide`}</inlineCode>{` request:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`curl -v -L \\
--header "Content-Type: application/json" \\
--header "HTTP_X_FORWARDED_FOR: the_client_ip_address_to_use " \\
-d '  {
    "api_key": "<ph_project_api_key>",
    "distinct_id": "distinct_id_of_your_user",
    "groups": { # Optional. Required only for group-based feature flags
        "group_type": "group_id" # Replace "group_type" with the name of your group type. Replace "group_id" with the id of your group.
    },
    "person_properties": {"<personProp1>": "<personVal1>"}, # Optional. Include any properties used to calculate the value of the feature flag.
    "group_properties": {"group type": {"<groupProp1>":"<groupVal1>"}} # Optional. Include any properties used to calculate the value of the feature flag.
}' https://us.posthog.com/decide?v=3 # or https://eu.posthog.com/decide?v=3
`}</code></pre>
    <p>{`The list of properties that this overrides:`}</p>
    <ol>
      <li parentName="ol">{`$geoip_city_name`}</li>
      <li parentName="ol">{`$geoip_country_name`}</li>
      <li parentName="ol">{`$geoip_country_code`}</li>
      <li parentName="ol">{`$geoip_continent_name`}</li>
      <li parentName="ol">{`$geoip_continent_code`}</li>
      <li parentName="ol">{`$geoip_postal_code`}</li>
      <li parentName="ol">{`$geoip_time_zone`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      